// Types
import { PushSubscriptionRequest } from './pushNotificationsRequest';

export type PushNotificationsExternalApi = {
    request: PushSubscriptionRequest;
};

declare global {
    // Declaration merging into Window only works with an interface.
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Window {
        __milanotePush?: PushNotificationsExternalApi;
    }
}

/** Exposes the subscribe request on `window.__milanotePush` so it can be driven from the console. */
export const installPushNotificationsExternalApi = (request: PushSubscriptionRequest): void => {
    if (typeof window === 'undefined') return;

    window.__milanotePush = { request };
};
